module.exports = __webpack_public_path__ + "static/media/lifestyle.39c09309.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/characteristics/lifestyle.svg
// module id = 872
// module chunks = 0